export default {
    id: -1,
    name: 'homeText',
    value: "Herzlich willkommen bei der <br>" +
        "Römisch-katholischen Kantonalkirche Schwyz",
    target: "/",
    Post: false,
    date: 20181203,
}